import React from 'react';
import locale from 'antd/lib/date-picker/locale/ru_RU';
import { Form, DatePicker } from 'antd';
import moment from 'moment';

const BirthDate = ({ isEditable, form }) => {
  const { getFieldDecorator } = form;
  const start_date_years = value => {
    return value.format('x') < moment().format('x');
  };
  return (
    <div className="b-form-fields">
      <div className="b-form-fields__item">
        <Form.Item label="Дата рождения">
          {getFieldDecorator('birthDate')(
            <DatePicker
              disabledDate={start_date_years}
              defaultPickerValue={moment('2001/01/01', 'DD.MM.YYYY')}
              style={{ width: 224 }}
              name="birthDate"
              placeholder="ДД.ММ.ГГГГ"
              format={'DD.MM.YYYY'}
              disabled={!isEditable}
              locale={locale}
            />
          )}
        </Form.Item>
      </div>
    </div>
  );
};

export default BirthDate;
